import {
  DashboardResourcesBS,
  DashboardResourcesDE,
  DashboardResourcesEN,
} from "../pages/dashboard/Dashboard1/Dashboard.resources";
import {
  FooterResourcesBS,
  FooterResourcesDE,
  FooterResourcesEN,
} from "../layouts/Footer.resources";
import {
  MenuItemsResourcesBS,
  MenuItemsResourcesDE,
  MenuItemsResourcesEN,
} from "../layouts/TwoColumn/MenuItems.resources";

import { AboutUsBS } from "../pages/AboutUs/AboutUs.resources";
import { AboutUsDE } from "../pages/AboutUs/AboutUs.resources.de";
import { AboutUsEN } from "../pages/AboutUs/AboutUs.resources.en";
import { CIPO_V1ResourcesBS } from "../pages/Evidencije/CIPO_V1/CIPO_V1.resources";
import { CIPO_V1ResourcesDE } from "../pages/Evidencije/CIPO_V1/CIPO_V1.resources.de";
import { CIPO_V1ResourcesEN } from "../pages/Evidencije/CIPO_V1/CIPO_V1.resources.en";
import { CIPP_V1ResourcesBS } from "../pages/Evidencije/CIPP_V1/CIPP_V1.resources";
import { CIPP_V1ResourcesDE } from "../pages/Evidencije/CIPP_V1/CIPP_V1.resources.de";
import { CIPP_V1ResourcesEN } from "../pages/Evidencije/CIPP_V1/CIPP_V1.resources.en";
import { DERATIZACIJA_V1_ResourcesBS } from "../pages/Evidencije/DERATIZACIJA_V1/DERATIZACIJA_V1.resources";
import { DERATIZACIJA_V1_ResourcesDE } from "../pages/Evidencije/DERATIZACIJA_V1/DERATIZACIJA_V1.resources.de";
import { DERATIZACIJA_V1_ResourcesEN } from "../pages/Evidencije/DERATIZACIJA_V1/DERATIZACIJA_V1.resources.en";
import { DEZINFEKCIJA_V1_ResourcesBS } from "../pages/Evidencije/DEZINFEKCIJA_V1/DEZINFEKCIJA_V1.resources";
import { DEZINFEKCIJA_V1_ResourcesDE } from "../pages/Evidencije/DEZINFEKCIJA_V1/DEZINFEKCIJA_V1.resources.de";
import { DEZINFEKCIJA_V1_ResourcesEN } from "../pages/Evidencije/DEZINFEKCIJA_V1/DEZINFEKCIJA_V1.resources.en";
import { DEZINSEKCIJA_V1_ResourcesBS } from "../pages/Evidencije/DEZINSEKCIJA_V1/DEZINSEKCIJA_V1.resources";
import { DEZINSEKCIJA_V1_ResourcesDE } from "../pages/Evidencije/DEZINSEKCIJA_V1/DEZINSEKCIJA_V1.resources.de";
import { DEZINSEKCIJA_V1_ResourcesEN } from "../pages/Evidencije/DEZINSEKCIJA_V1/DEZINSEKCIJA_V1.resources.en";
import { DEZSR_V1ResourcesBS } from "../pages/Evidencije/DEZSR_V1/DEZSR_V1.resources";
import { DEZSR_V1ResourcesDE } from "../pages/Evidencije/DEZSR_V1/DEZSR_V1.resources.de";
import { DEZSR_V1ResourcesEN } from "../pages/Evidencije/DEZSR_V1/DEZSR_V1.resources.en";
import { DOBAVLJAC_V1ResourcesBS } from "../pages/Evidencije/DOBAVLJAC_V1/DOBAVLJAC_V1.resources";
import { DOBAVLJAC_V1ResourcesDE } from "../pages/Evidencije/DOBAVLJAC_V1/DOBAVLJAC_V1.resources.de";
import { DOBAVLJAC_V1ResourcesEN } from "../pages/Evidencije/DOBAVLJAC_V1/DOBAVLJAC_V1.resources.en";
import { DOSTAVA_V1ResourcesBS } from "../pages/Evidencije/DOSTAVA_V1/DOSTAVA_V1.resources";
import { DOSTAVA_V1ResourcesDE } from "../pages/Evidencije/DOSTAVA_V1/DOSTAVA_V1.resources.de";
import { DOSTAVA_V1ResourcesEN } from "../pages/Evidencije/DOSTAVA_V1/DOSTAVA_V1.resources.en";
import { DodavanjeKorisnikaResourcesBS } from "../pages/DodavanjeKorisnika/DodavanjeKorisnika/DodavanjeKorisnika.resources";
import { EDUZAP_V1ResourcesBS } from "../pages/Evidencije/EDUZAP_V1/EDUZAP_V1.resources";
import { EDUZAP_V1ResourcesDE } from "../pages/Evidencije/EDUZAP_V1/EDUZAP_V1.resources.de";
import { EDUZAP_V1ResourcesEN } from "../pages/Evidencije/EDUZAP_V1/EDUZAP_V1.resources.en";
import { EvidencijeResourcesBS } from "../pages/Evidencije/Evidencije.resources";
import { EvidencijeResourcesDE } from "../pages/Evidencije/Evidencije.resources.de";
import { EvidencijeResourcesEN } from "../pages/Evidencije/Evidencije.resources.en";
import { FeedbackResourceBS } from "../pages/Feedback/Feedback.resources";
import { FeedbackResourceDE } from "../pages/Feedback/Feedback.resources";
import { FeedbackResourceEN } from "../pages/Feedback/Feedback.resources";
import { FeedbackReviewResourceBS } from "../pages/FeedbackReview/FeedbackReview.resources";
import { FeedbackReviewResourceDE } from "../pages/FeedbackReview/FeedbackReview.resources";
import { FeedbackReviewResourceEN } from "../pages/FeedbackReview/FeedbackReview.resources";
import { FirstLoginResourcesBS } from "../pages/FirstLogin/FirstLogin.resources";
import { FirstLoginResourcesDE } from "../pages/FirstLogin/FirstLogin.resources.de";
import { FirstLoginResourcesEN } from "../pages/FirstLogin/FirstLogin.resources.en";
import { GetQRResourcesBS } from "../pages/QR/GetQR/GetQR.resources";
import { GetQRResourcesDE } from "../pages/QR/GetQR/GetQR.resources.de";
import { GetQRResourcesEN } from "../pages/QR/GetQR/GetQR.resources.en";
import { KatalogEvidencijaPoPotrebiResourcesBS } from "../pages/EvidencijePoPotrebi/EvidencijePoPotrebi.resources";
import { KatalogEvidencijaPoPotrebiResourcesDE } from "../pages/EvidencijePoPotrebi/EvidencijePoPotrebi.resources.de";
import { KatalogEvidencijaPoPotrebiResourcesEN } from "../pages/EvidencijePoPotrebi/EvidencijePoPotrebi.resources.en";
import { KatalogEvidencijaResourcesBS } from "../pages/KatalogEvidencija/KatalogEvidencija.resources";
import { KatalogEvidencijaResourcesDE } from "../pages/KatalogEvidencija/KatalogEvidencija.resources.de";
import { KatalogEvidencijaResourcesEN } from "../pages/KatalogEvidencija/KatalogEvidencija.resources.en";
import LanguageDetector from "i18next-browser-languagedetector";
import { ListaEvidencijaResourcesBS } from "../pages/lists/ListaEvidencija/ListaEvidencija.resources";
import { ListaEvidencijaResourcesDE } from "../pages/lists/ListaEvidencija/ListaEvidencija.resources.de";
import { ListaEvidencijaResourcesEN } from "../pages/lists/ListaEvidencija/ListaEvidencija.resources.en";
import { ListaKompanijaResourcesBS } from "../pages/lists/ListaKompanija/ListaKompanija.resources";
import { ListaKompanijaResourcesDE } from "../pages/lists/ListaKompanija/ListaKompanija.resources.de";
import { ListaKompanijaResourcesEN } from "../pages/lists/ListaKompanija/ListaKompanija.resources.en";
import { ListaRadnogVremenaResourcesBS } from "../pages/lists/ListaRadnogVremena/ListaRadnogVremena.resources";
import { ListaRadnogVremenaResourcesDE } from "../pages/lists/ListaRadnogVremena/ListaRadnogVremena.resources.de";
import { ListaRadnogVremenaResourcesEN } from "../pages/lists/ListaRadnogVremena/ListaRadnogVremena.resources.en";
import { ListaRadnogVremenaGpsResourceBS } from "../pages/lists/ListaRadnogVremenaGps/ListaRadnogVremenaGps.resources";
import { ListaRadnogVremenaGpsResourceDE } from "../pages/lists/ListaRadnogVremenaGps/ListaRadnogVremenaGps.resources";
import { ListaRadnogVremenaGpsResourceEN } from "../pages/lists/ListaRadnogVremenaGps/ListaRadnogVremenaGps.resources";
import { MonitoringDashboardResourcesBS } from "../pages/dashboard/MonitoringDashboard/MonitoringDashboard.resources";
import { MonitoringDashboardResourcesDE } from "../pages/dashboard/MonitoringDashboard/MonitoringDashboard.resources";
import { MonitoringDashboardResourcesEN } from "../pages/dashboard/MonitoringDashboard/MonitoringDashboard.resources";
import { MOL_V1ResourcesBS } from "../pages/Evidencije/MOL_V1/MOL_V1.resources";
import { MOL_V1ResourcesDE } from "../pages/Evidencije/MOL_V1/MOL_V1.resources.de";
import { MOL_V1ResourcesEN } from "../pages/Evidencije/MOL_V1/MOL_V1.resources.en";
import { MyAccountResourcesBS } from "../pages/MyAccount/MyAccount.resources";
import { MyAccountResourcesDE } from "../pages/MyAccount/MyAccount.resources.de";
import { MyAccountResourcesEN } from "../pages/MyAccount/MyAccount.resources.en";
import {
  NeradniDanResourcesBS,
  NeradniDanResourcesDE,
  NeradniDanResourcesEN,
} from "../pages/administracija/NeradniDan/NeradniDan.resources";
import { OPREMA_V1ResourcesBS } from "../pages/Evidencije/OPREMA_V1/OPREMA_V1.resources";
import { OPREMA_V1ResourcesDE } from "../pages/Evidencije/OPREMA_V1/OPREMA_V1.resources.de";
import { OPREMA_V1ResourcesEN } from "../pages/Evidencije/OPREMA_V1/OPREMA_V1.resources.en";
import { OTPAD_V1ResourcesBS } from "../pages/Evidencije/OTPAD_V1/OTPAD_V1.resources";
import { OTPAD_V1ResourcesDE } from "../pages/Evidencije/OTPAD_V1/OTPAD_V1.resources.de";
import { OTPAD_V1ResourcesEN } from "../pages/Evidencije/OTPAD_V1/OTPAD_V1.resources.en";
import { PRIJEMROBE_V1ResourcesBS } from "../pages/Evidencije/PRIJEMROBE_V1/PRIJEMROBE_V1.resources";
import { PRIJEMROBE_V1ResourcesDE } from "../pages/Evidencije/PRIJEMROBE_V1/PRIJEMROBE_V1.resources.de";
import { PRIJEMROBE_V1ResourcesEN } from "../pages/Evidencije/PRIJEMROBE_V1/PRIJEMROBE_V1.resources.en";
import { RadnoVrijemeEvdResourceBS } from "../pages/RadnoVrijemeEvd/RadnoVrijemeEvd.resources";
import { RadnoVrijemeEvdResourceDE } from "../pages/RadnoVrijemeEvd/RadnoVrijemeEvd.resources.de";
import { RadnoVrijemeEvdResourceEN } from "../pages/RadnoVrijemeEvd/RadnoVrijemeEvd.resources.en";
import { RadnoVrijemeGpsEvdResourceBS } from "../pages/RadnoVrijemeGpsEvd/RadnoVrijemeGpsEvd.resources";
import { RadnoVrijemeGpsEvdResourceDE } from "../pages/RadnoVrijemeGpsEvd/RadnoVrijemeGpsEvd.resources.de";
import { RadnoVrijemeGpsEvdResourceEN } from "../pages/RadnoVrijemeGpsEvd/RadnoVrijemeGpsEvd.resources.en";
import { RadnoVrijemeGpsEvdManagerResourceBS } from "../pages/RadnoVrijemeGpsEvdManager/RadnoVrijemeGpsEvdManager.resources";
import { RadnoVrijemeGpsEvdManagerResourceDE } from "../pages/RadnoVrijemeGpsEvdManager/RadnoVrijemeGpsEvdManager.resources";
import { RadnoVrijemeGpsEvdManagerResourceEN } from "../pages/RadnoVrijemeGpsEvdManager/RadnoVrijemeGpsEvdManager.resources";
import { RadnoVrijemeSumEvdResourceBS } from "../pages/lists/RadnoVrijemeSumEvd/RadnoVrijemeSumEvd.resources";
import { RadnoVrijemeSumEvdResourceDE } from "../pages/lists/RadnoVrijemeSumEvd/RadnoVrijemeSumEvd.resources.de";
import { RadnoVrijemeSumEvdResourceEN } from "../pages/lists/RadnoVrijemeSumEvd/RadnoVrijemeSumEvd.resources.en";
import { PregledSihtaricaResourceBS } from "../pages/lists/PregledSihtarica/PregledSihtarica.resources";
import { PregledSihtaricaResourceDE } from "../pages/lists/PregledSihtarica/PregledSihtarica.resources.de";
import { PregledSihtaricaResourceEN } from "../pages/lists/PregledSihtarica/PregledSihtarica.resources.en";
import { RegistracijaKompanijeResourcesBS } from "../pages/RegistracijaKompanije/RegistracijaKompanije.resources";
import { RegistracijaKompanijeResourcesDE } from "../pages/RegistracijaKompanije/RegistracijaKompanije.resources.de";
import { RegistracijaKompanijeResourcesEN } from "../pages/RegistracijaKompanije/RegistracijaKompanije.resources.en";
import { SAN_V1ResourcesBS } from "../pages/Evidencije/SAN_V1/SAN_V1.resources";
import { SAN_V1ResourcesDE } from "../pages/Evidencije/SAN_V1/SAN_V1.resources.de";
import { SAN_V1ResourcesEN } from "../pages/Evidencije/SAN_V1/SAN_V1.resources.en";
import { SignatureCanvasResourcesBS } from "../components/SignatureCanvas/SignatureCanvas.resources";
import { SignatureCanvasResourcesDE } from "../components/SignatureCanvas/SignatureCanvas.resources.de";
import { SignatureCanvasResourcesEN } from "../components/SignatureCanvas/SignatureCanvas.resources.en";
import { TEMPERATURAKKTPROIZVODI_V1ResourcesBS } from "../pages/Evidencije/TEMPERATURAKKTPROIZVODI_V1/TEMPERATURAKKTPROIZVODI_V1.resources";
import { TEMPERATURAKKTPROIZVODI_V1ResourcesDE } from "../pages/Evidencije/TEMPERATURAKKTPROIZVODI_V1/TEMPERATURAKKTPROIZVODI_V1.resources.de";
import { TEMPERATURAKKTPROIZVODI_V1ResourcesEN } from "../pages/Evidencije/TEMPERATURAKKTPROIZVODI_V1/TEMPERATURAKKTPROIZVODI_V1.resources.en";
import { TEMPERATURAOGRANICENAKKT_V1ResourcesBS } from "../pages/Evidencije/TEMPERATURAOGRANICENAKKT_V1/TEMPERATURAOGRANICENAKKT_V1.resources";
import { TEMPERATURAOGRANICENAKKT_V1ResourcesDE } from "../pages/Evidencije/TEMPERATURAOGRANICENAKKT_V1/TEMPERATURAOGRANICENAKKT_V1.resources.de";
import { TEMPERATURAOGRANICENAKKT_V1ResourcesEN } from "../pages/Evidencije/TEMPERATURAOGRANICENAKKT_V1/TEMPERATURAOGRANICENAKKT_V1.resources.en";
import { TEMPERATURAOGRANICENA_V1ResourcesBS } from "../pages/Evidencije/TEMPERATURAOGRANICENA_V1/TEMPERATURAOGRANICENA_V1.resources";
import { TEMPERATURAOGRANICENA_V1ResourcesDE } from "../pages/Evidencije/TEMPERATURAOGRANICENA_V1/TEMPERATURAOGRANICENA_V1.resources.de";
import { TEMPERATURAOGRANICENA_V1ResourcesEN } from "../pages/Evidencije/TEMPERATURAOGRANICENA_V1/TEMPERATURAOGRANICENA_V1.resources.en";
import { TEMPERATURA_V1ResourcesBS } from "../pages/Evidencije/TEMPERATURA_V1/TEMPERATURA_V1.resources";
import { TEMPERATURA_V1ResourcesDE } from "../pages/Evidencije/TEMPERATURA_V1/TEMPERATURA_V1.resources.de";
import { TEMPERATURA_V1ResourcesEN } from "../pages/Evidencije/TEMPERATURA_V1/TEMPERATURA_V1.resources.en";
import { TackePrimjeneResourcesBS } from "../pages/TackePrimjene/TackePrimjene.resources";
import { TackePrimjeneResourcesDE } from "../pages/TackePrimjene/TackePrimjene.resources.de";
import { TackePrimjeneResourcesEN } from "../pages/TackePrimjene/TackePrimjene.resources.en";
import { UpravljanjeKorisnicimaResourcesBS } from "../pages/DodavanjeKorisnika/UpravljanjeKorisnicima/UpravljanjeKorisnicima.resources";
import { UpravljanjeKorisnicimaResourcesDE } from "../pages/DodavanjeKorisnika/UpravljanjeKorisnicima/UpravljanjeKorisnicima.resources.de";
import { UpravljanjeKorisnicimaResourcesEN } from "../pages/DodavanjeKorisnika/UpravljanjeKorisnicima/UpravljanjeKorisnicima.resources.en";
import { FileUploadResourcesBS, FileUploadResourcesDE, FileUploadResourcesEN } from "../pages/FileUpload/FileUpload.resources";
import { ListDocumentsResourcesBS, ListDocumentsResourcesDE, ListDocumentsResourcesEN } from "../pages/ListDocuments/ListDocuments.resources";
import { Error404ResourcesBS, Error404ResourcesDE, Error404ResourcesEN } from "../pages/error/Error404.resources";
import { authBS } from "../pages/auth/Auth.resources";
import { authDE } from "../pages/auth/Auth.resources.de";
import { authEN } from "../pages/auth/Auth.resources.en";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  bs: {
    translation: {
      auth: authBS,
      registracijaKompanije: RegistracijaKompanijeResourcesBS,
      menuItems: MenuItemsResourcesBS,
      dodavanjeKorisnika: DodavanjeKorisnikaResourcesBS,
      katalogEvidencija: KatalogEvidencijaResourcesBS,
      evidencije: EvidencijeResourcesBS,
      dashboard: DashboardResourcesBS,
      CIPP_V1: CIPP_V1ResourcesBS,
      CIPO_V1: CIPO_V1ResourcesBS,
      firstLogin: FirstLoginResourcesBS,
      signatureCanvas: SignatureCanvasResourcesBS,
      evidencijePoPotrebi: KatalogEvidencijaPoPotrebiResourcesBS,
      listaKompanija: ListaKompanijaResourcesBS,
      listaEvidencija: ListaEvidencijaResourcesBS,
      dezinsekcija_v1: DEZINSEKCIJA_V1_ResourcesBS,
      deratizacija_v1: DERATIZACIJA_V1_ResourcesBS,
      dezinfekcija_v1: DEZINFEKCIJA_V1_ResourcesBS,
      dezsr_v1: DEZSR_V1ResourcesBS,
      dobavljac_v1: DOBAVLJAC_V1ResourcesBS,
      dostava_v1: DOSTAVA_V1ResourcesBS,
      eduzap_v1: EDUZAP_V1ResourcesBS,
      mol_v1: MOL_V1ResourcesBS,
      oprema_v1: OPREMA_V1ResourcesBS,
      otpad_v1: OTPAD_V1ResourcesBS,
      prijemRobe_v1: PRIJEMROBE_V1ResourcesBS,
      san_v1: SAN_V1ResourcesBS,
      temperatura_v1: TEMPERATURA_V1ResourcesBS,
      upravljanjeKorisnicima: UpravljanjeKorisnicimaResourcesBS,
      tackePrimjene: TackePrimjeneResourcesBS,
      dodavanjeKompanije: RegistracijaKompanijeResourcesBS,
      temperaturaogranicena_v1: TEMPERATURAOGRANICENA_V1ResourcesBS,
      temperaturaogranicenakkt_v1: TEMPERATURAOGRANICENAKKT_V1ResourcesBS,
      temperaturakktproizvodi_v1: TEMPERATURAKKTPROIZVODI_V1ResourcesBS,
      footer: FooterResourcesBS,
      aboutus: AboutUsBS,
      myaccount: MyAccountResourcesBS,
      radnoVrijeme: RadnoVrijemeEvdResourceBS,
      radnoVrijemeGps: RadnoVrijemeGpsEvdResourceBS,
      radnoVrijemeGpsManager: RadnoVrijemeGpsEvdManagerResourceBS,
      listaRadnoVrijeme: ListaRadnogVremenaResourcesBS,
      listaRadnoVrijemeSum: RadnoVrijemeSumEvdResourceBS,
      pregledSihtarica: PregledSihtaricaResourceBS,
      listaRadnoVrijemeGps: ListaRadnogVremenaGpsResourceBS,
      getQR: GetQRResourcesBS,
      feedback: FeedbackResourceBS,
      feedbackReview: FeedbackReviewResourceBS,
      monitoringDashboard: MonitoringDashboardResourcesBS,
      fileUpload: FileUploadResourcesBS,
      listDocuments: ListDocumentsResourcesBS,
      error404: Error404ResourcesBS,
      neradniDan: NeradniDanResourcesBS,
    },
  },
  de: {
    translation: {
      auth: authDE,
      registracijaKompanije: RegistracijaKompanijeResourcesBS,
      menuItems: MenuItemsResourcesDE,
      dodavanjeKorisnika: DodavanjeKorisnikaResourcesBS,
      katalogEvidencija: KatalogEvidencijaResourcesDE,
      evidencije: EvidencijeResourcesDE,
      dashboard: DashboardResourcesDE,
      CIPP_V1: CIPP_V1ResourcesDE,
      CIPO_V1: CIPO_V1ResourcesDE,
      firstLogin: FirstLoginResourcesDE,
      signatureCanvas: SignatureCanvasResourcesDE,
      evidencijePoPotrebi: KatalogEvidencijaPoPotrebiResourcesDE,
      listaKompanija: ListaKompanijaResourcesDE,
      listaEvidencija: ListaEvidencijaResourcesDE,
      dezinsekcija_v1: DEZINSEKCIJA_V1_ResourcesDE,
      deratizacija_v1: DERATIZACIJA_V1_ResourcesDE,
      dezinfekcija_v1: DEZINFEKCIJA_V1_ResourcesDE,
      dezsr_v1: DEZSR_V1ResourcesDE,
      dobavljac_v1: DOBAVLJAC_V1ResourcesDE,
      dostava_v1: DOSTAVA_V1ResourcesDE,
      eduzap_v1: EDUZAP_V1ResourcesDE,
      mol_v1: MOL_V1ResourcesDE,
      oprema_v1: OPREMA_V1ResourcesDE,
      otpad_v1: OTPAD_V1ResourcesDE,
      prijemRobe_v1: PRIJEMROBE_V1ResourcesDE,
      san_v1: SAN_V1ResourcesDE,
      temperatura_v1: TEMPERATURA_V1ResourcesDE,
      upravljanjeKorisnicima: UpravljanjeKorisnicimaResourcesDE,
      tackePrimjene: TackePrimjeneResourcesDE,
      dodavanjeKompanije: RegistracijaKompanijeResourcesDE,
      temperaturaogranicena_v1: TEMPERATURAOGRANICENA_V1ResourcesDE,
      temperaturaogranicenakkt_v1: TEMPERATURAOGRANICENAKKT_V1ResourcesDE,
      temperaturakktproizvodi_v1: TEMPERATURAKKTPROIZVODI_V1ResourcesDE,
      footer: FooterResourcesDE,
      aboutus: AboutUsDE,
      myaccount: MyAccountResourcesDE,
      radnoVrijeme: RadnoVrijemeEvdResourceDE,
      radnoVrijemeGps: RadnoVrijemeGpsEvdResourceDE,
      radnoVrijemeGpsManager: RadnoVrijemeGpsEvdManagerResourceDE,
      listaRadnoVrijeme: ListaRadnogVremenaResourcesDE,
      listaRadnoVrijemeSum: RadnoVrijemeSumEvdResourceDE,
      pregledSihtarica: PregledSihtaricaResourceDE,
      listaRadnoVrijemeGps: ListaRadnogVremenaGpsResourceDE,
      getQR: GetQRResourcesDE,
      feedback: FeedbackResourceDE,
      feedbackReview: FeedbackReviewResourceDE,
      monitoringDashboard: MonitoringDashboardResourcesDE,
      fileUpload: FileUploadResourcesDE,
      listDocuments: ListDocumentsResourcesDE,
      error404: Error404ResourcesDE,
      neradniDan: NeradniDanResourcesDE,
    },
  },
  en: {
    translation: {
      auth: authEN,
      registracijaKompanije: RegistracijaKompanijeResourcesEN,
      menuItems: MenuItemsResourcesEN,
      dodavanjeKorisnika: DodavanjeKorisnikaResourcesBS,
      katalogEvidencija: KatalogEvidencijaResourcesEN,
      evidencije: EvidencijeResourcesEN,
      dashboard: DashboardResourcesEN,
      CIPP_V1: CIPP_V1ResourcesEN,
      CIPO_V1: CIPO_V1ResourcesEN,
      firstLogin: FirstLoginResourcesEN,
      signatureCanvas: SignatureCanvasResourcesEN,
      evidencijePoPotrebi: KatalogEvidencijaPoPotrebiResourcesEN,
      listaKompanija: ListaKompanijaResourcesEN,
      listaEvidencija: ListaEvidencijaResourcesEN,
      dezinsekcija_v1: DEZINSEKCIJA_V1_ResourcesEN,
      deratizacija_v1: DERATIZACIJA_V1_ResourcesEN,
      dezinfekcija_v1: DEZINFEKCIJA_V1_ResourcesEN,
      dezsr_v1: DEZSR_V1ResourcesEN,
      dobavljac_v1: DOBAVLJAC_V1ResourcesEN,
      dostava_v1: DOSTAVA_V1ResourcesEN,
      eduzap_v1: EDUZAP_V1ResourcesEN,
      mol_v1: MOL_V1ResourcesEN,
      oprema_v1: OPREMA_V1ResourcesEN,
      otpad_v1: OTPAD_V1ResourcesEN,
      prijemRobe_v1: PRIJEMROBE_V1ResourcesEN,
      san_v1: SAN_V1ResourcesEN,
      temperatura_v1: TEMPERATURA_V1ResourcesEN,
      upravljanjeKorisnicima: UpravljanjeKorisnicimaResourcesEN,
      tackePrimjene: TackePrimjeneResourcesEN,
      dodavanjeKompanije: RegistracijaKompanijeResourcesEN,
      temperaturaogranicena_v1: TEMPERATURAOGRANICENA_V1ResourcesEN,
      temperaturaogranicenakkt_v1: TEMPERATURAOGRANICENAKKT_V1ResourcesEN,
      temperaturakktproizvodi_v1: TEMPERATURAKKTPROIZVODI_V1ResourcesEN,
      footer: FooterResourcesEN,
      aboutus: AboutUsEN,
      myaccount: MyAccountResourcesEN,
      radnoVrijeme: RadnoVrijemeEvdResourceEN,
      radnoVrijemeGps: RadnoVrijemeGpsEvdResourceEN,
      radnoVrijemeGpsManager: RadnoVrijemeGpsEvdManagerResourceEN,
      listaRadnoVrijeme: ListaRadnogVremenaResourcesEN,
      listaRadnoVrijemeSum: RadnoVrijemeSumEvdResourceEN,
      pregledSihtarica: PregledSihtaricaResourceEN,
      listaRadnoVrijemeGps: ListaRadnogVremenaGpsResourceEN,
      getQR: GetQRResourcesEN,
      feedback: FeedbackResourceEN,
      feedbackReview: FeedbackReviewResourceEN,
      monitoringDashboard: MonitoringDashboardResourcesEN,
      fileUpload: FileUploadResourcesEN,
      listDocuments: ListDocumentsResourcesEN,
      error404: Error404ResourcesEN,
      neradniDan: NeradniDanResourcesEN,
    },
  },
};

i18next
  // Binding our instance to an internal store
  .use(initReactI18next)
  // .use(Backend)
  // TODO: Language detector is not saving the cookies
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "bs",
    // Only en for example, without en-US or en-UK
    load: "languageOnly",
    // Allowed languages | how to get them in our components: i18n.options.supportedLngs
    // supportedLngs: ["bs", "en", "de"],
    supportedLngs: ["bs", "de", "en"],
    debug: true,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
      // Map closely related locales so we use Bosnian strings instead of e.g. English
      // when the browser lists hr/sr before en (see i18next getBestMatchFromCodes).
      convertDetectedLanguage: (lng: string) => {
        const base = lng.split("-")[0]?.toLowerCase();
        if (base === "hr" || base === "sr") return "bs";
        return lng;
      },
    },
  });

export default i18next;
